import { noop } from '@datadog/browser-core';
import { LifeCycleEventType } from './lifeCycle';
export function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    var subscriptions = [];
    subscriptions.push(lifeCycle.subscribe(LifeCycleEventType.ERROR_COLLECTED, function () {
        eventCounts.errorCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(LifeCycleEventType.AUTO_ACTION_COMPLETED, function () {
        eventCounts.userActionCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(LifeCycleEventType.CUSTOM_ACTION_COLLECTED, function () {
        eventCounts.userActionCount += 1;
        callback(eventCounts);
    }));
    subscriptions.push(lifeCycle.subscribe(LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType === 'longtask') {
            eventCounts.longTaskCount += 1;
            callback(eventCounts);
        }
    }));
    subscriptions.push(lifeCycle.subscribe(LifeCycleEventType.RESOURCE_ADDED_TO_BATCH, function () {
        eventCounts.resourceCount += 1;
        callback(eventCounts);
    }));
    return {
        stop: function () {
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map